var wrapWords = function (text, before, after, join) {
  join = join || ' '
  var words = text.split(' ')
  for (var i = 0; i < words.length; i++) {
    words[i] = before + words[i] + after
  }
  return words.join(join)
}

var wrapWordsInChildElement = function (el) {
  if (el.parentElement && el.parentElement.className == 'js-detect-wrap') {
    return
  }
  if (el.nodeName == '#text') {
    var words = el.textContent.split(' ')
    for (var i = 0; i < words.length; i++) {
      if (words[i].length > 0) {
        var span = document.createElement('span')
        span.className = 'js-detect-wrap'
        span.innerText = words[i]
        el.parentNode.insertBefore(span, el)
      }
      if (i < words.length - 1) el.parentNode.insertBefore(document.createTextNode(' '), el)
    }
    el.parentNode.removeChild(el)
  } else {
    if (el.innerText) {
      el.innerHTML = wrapWords(el.innerText, '<span class="js-detect-wrap">', '</span>')
    }
  }
}

var wrapWordsInElement = function (el) {
  if (!el.firstChild) {
    wrapWordsInChildElement(el)
  } else {
    var siblings = []
    var s = el.firstChild
    do {
      siblings.push(s)
    } while (s.nextSibling)
    {
      s = s.nextSibling
    }

    for (var i = 0; i < siblings.length; i++) {
      wrapWordsInElement(siblings[i])
    }
  }
}

var getLines = function (el) {
  let clone = el.cloneNode(true)
  el.parentElement.append(clone)
  wrapWordsInElement(clone)

  var spans = clone.getElementsByClassName('js-detect-wrap')

  var lastOffset = 0,
    line = [],
    lines = [],
    l = 0
  for (var i = 0; i < spans.length; i++) {
    var offset = spans[i].offsetTop + spans[i].getBoundingClientRect().height
    if (offset == lastOffset) {
      line.push(spans[i])
    } else {
      if (line.length > 0) lines[l++] = line

      line = [spans[i]]
    }
    lastOffset = offset
  }
  lines.push(line)
  el.parentElement.removeChild(clone)
  return lines
}

var detector = {
  wrapWords: wrapWords,
  wrapWordsInElement: wrapWordsInElement,
  wrapWordsInChildElement: wrapWordsInChildElement,
  getLines: getLines,
}

export default detector

import { select as d3_select } from 'd3-selection'

export function wrapSvgText(text, width) {
  text.each(function () {
    var text = d3_select(this),
      src = text.text().replaceAll('-', '- '),
      words = src.split(/\s+/).reverse(),
      word

    if (words.length === 1) return

    var line = [],
      lineNumber = 0,
      lineHeight = 1.1, // ems
      y = text.attr('y') || 0,
      x = text.attr('x') || 0,
      dy = parseFloat(text.attr('dy') || 0),
      tspan = text
        .text(null)
        .append('tspan')
        .attr('x', x)
        .attr('y', y)
        .attr('dy', dy + 'em')

    word = words.pop()
    while (word) {
      line.push(word)
      tspan.text(line.join(' '))
      if (tspan.node().getComputedTextLength() > width && line.length > 1) {
        line.pop()
        tspan.text(line.join(' '))
        line = [word]
        tspan.text(tspan.text().replace('- ', '-'))
        tspan = text
          .append('tspan')
          .attr('x', x)
          .attr('y', y)
          .attr('dy', ++lineNumber * lineHeight + dy + 'em')
          .text(word)
      }
      word = words.pop()
      tspan.text(tspan.text().replace('- ', '-'))
    }
  })
}

export function ellipseSvgText(text, width) {
  text.each(function () {
    let currentWidth = this.getComputedTextLength()
    let currentText = this.innerHTML

    while (currentWidth > width) {
      console.log(currentWidth, width)
      currentText = currentText.slice(0, -1)
      this.innerHTML = currentText + '...'
      currentWidth = this.getComputedTextLength()
    }
  })
}
